function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function adaptation1AdaptFacetValue(facetValue) {
  var additionalFacetValueFieldsForField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var count = facetValue.count,
      value = facetValue.value,
      rest = _objectWithoutProperties(facetValue, ["count", "value"]);

  return {
    count: count,
    value: value ? value : _objectSpread({}, rest, additionalFacetValueFieldsForField)
  };
}

function adaptation2AddLabelToFacet(fieldName, facet) {
  return _objectSpread({
    field: fieldName
  }, facet);
}

function adaptFacets(facets, _ref) {
  var _ref$additionalFacetV = _ref.additionalFacetValueFields,
      additionalFacetValueFields = _ref$additionalFacetV === void 0 ? {} : _ref$additionalFacetV;
  if (!facets || Object.keys(facets).length === 0) return facets;
  return Object.entries(facets).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        fieldName = _ref3[0],
        facet = _ref3[1];

    var adaptedFacet = facet.map(function (v) {
      var type = v.type,
          data = v.data,
          rest = _objectWithoutProperties(v, ["type", "data"]);

      return adaptation2AddLabelToFacet(fieldName, _objectSpread({
        type: type,
        data: data.map(function (f) {
          return adaptation1AdaptFacetValue(f, additionalFacetValueFields[fieldName]);
        })
      }, rest));
    });
    return _objectSpread({}, acc, _defineProperty({}, fieldName, adaptedFacet));
  }, {});
}

export function adaptResponse(response) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var facets = response.info.facets;
  var requestId = response.info.meta.request_id;
  var totalPages = response.info.meta.page ? response.info.meta.page.total_pages : undefined;
  var totalResults = response.info.meta.page ? response.info.meta.page.total_results : undefined;
  return _objectSpread({}, facets && {
    facets: adaptFacets(facets, options)
  }, {
    requestId: requestId,
    results: response.rawResults
  }, totalPages !== undefined && {
    totalPages: totalPages
  }, totalResults !== undefined && {
    totalResults: totalResults
  });
}